export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'thumbImageUrl',
    minWidth: 110,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'imageUrl' },
  },
  {
    title: that.$l('table_label_fabric') || '面料',
    field: 'fabric',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'fabric' },
  },
  {
    title: that.$l('table_label_fabric_wid_weight') || '克重/门幅',
    field: 'fabricWidWeight',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'fabricWidWeight' },
  },
  {
    title: that.$l('table_label_color') || '颜色',
    field: 'color',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'color' },
  },
  {
    title: that.$l('table_label_demandPersonName') || '需求人',
    field: 'demandPersonName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'demandPerson' },
  },

  {
    title: that.$l('table_label_demandQty') || '需求数量',
    field: 'demandQty',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
  },
  {
    title: that.$l('table_label_purchaseQty') || '采购数量',
    field: 'purchaseQty',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
  },
  {
    title: that.$l('table_label_unitPrice') || '采购单价',
    field: 'unitPrice',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '小计金额',
    field: 'subAmount',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
  },
  {
    title: that.$l('table_label_surchargeAmount') || '附加费金额',
    field: 'surchargeAmount',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_remark') || '备注',
    field: 'remark',
    minWidth: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 200,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        disabled: that.fabricDisabled,
        clearable: true,
      },
    },
  },
]
